import './contact-request.css';
import { useState, useCallback } from 'react';
import { TakeTour } from './take-tour';
import { AskQuestion } from './ask-question';
import { ContactAgent } from './contact-agent';
import { IBranding } from '../../../models/branding.model';
import { iconEye, iconUser, iconQuestion } from '../../../util/icons';

export interface ContactRequestProps {
  address: string;
  mlsId: string;
  branding: IBranding;
}

export const ContactRequest = (props: ContactRequestProps) => {

  const [contactType, setContactType] = useState('');
  const isBrokerage = false;

  const close = useCallback(() => {
    setContactType('');
  }, []);

  return (
    <div className="contact-request">
      <div className="contact-request-buttons">
        <div><button className={contactType === 'ask-question' ? 'cta-button cta-button-selected' : 'cta-button'} onClick={() => setContactType(contactType === 'ask-question' ? '' : 'ask-question')}>{iconQuestion} Ask Question</button></div>
        <div><button className={contactType === 'take-tour' ? 'cta-button cta-button-selected' : 'cta-button'} onClick={() => setContactType(contactType === 'take-tour' ? '' : 'take-tour')}>{iconEye} Take Tour</button></div>
        {isBrokerage &&
          <div><button className={contactType === 'contact-agent' ? 'cta-button cta-button-selected' : 'cta-button'} onClick={() => setContactType(contactType === 'contact-agent' ? '' : 'contact-agent')}>{iconUser} Contact Agent</button></div>
        }
      </div>
      {contactType === 'ask-question' &&
        <AskQuestion close={close} address={props.address} mlsId={props.mlsId} />
      }
      {contactType === 'take-tour' &&
        <TakeTour close={close} address={props.address} mlsId={props.mlsId} />
      }
      {contactType === 'contact-agent' &&
        <ContactAgent address={props.address} mlsId={props.mlsId} branding={props.branding} close={close} />
      }
    </div>
  );
}
